import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { PostmethodService } from "../../app-config/postmethod.service";

@Injectable({
  providedIn: "root",
})
export class UsersService {
  private apiUrl = `${environment.baseUrlResetPass}user`;
  private mspinUrl = `${environment.baseUrlResetPass}admin/master/masterRecords?type=24`;

  constructor(private http: HttpClient, private ws: PostmethodService) { }

  createUser(userData: any): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });

    console.log(userData);
    return this.http.post(this.apiUrl, userData, { headers });
  }

  getUserList(): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.apiUrl}/list`, { headers });
  }
  updateUser(id: number, data: any) {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.put(`${this.apiUrl}/update-profile/${id}`, data, { headers });
  }

  getMspin(): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.mspinUrl}`, { headers });
  }

  resetPassword(payload: { username: string, password: string; cpassword: string }): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.post(`${environment.baseUrlResetPass}/auth/resetPassword`, payload, { headers });
  }

    getUserExport() {
    return this.ws.wsGet(environment.loginUrl + "/reports/userGenerateReport");
  }

    getMasters() {
    return this.ws.wsGet(environment.loginUrl + "/admin/master/masterRecords");
  }

   getExportData(request:any) {
    return this.ws.wsPost(request, environment.loginUrl + "/reports/userExportReport");
  }

  userUnBlock(request:any) {
    return this.ws.wsPutById(environment.loginUrl + "/user/unblockUser", request.id );
  }

  exportManpower() {
    return this.ws.wsGet(environment.loginUrl + "/reports/manpowerUsers");
  }
}
